import { ArticleViewPage } from "@features/creation/articles/components/ArticleViewPage";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Eye } from "lucide-react";

export const Route = createFileRoute("/_app/creation/articles/$id/view")({
  loader: requirePermission(PERMISSIONS.CREATION.ARTICLES.VIEW),
  staticData: {
    title: "Détail article",
    icon: Eye,
    permission: PERMISSIONS.CREATION.ARTICLES.VIEW,
    section: "Creation",
    showInBreadcrumb: true,
  },
  component: ArticleViewPage,
});
